export type FolderDTO = {
  id: number;
  name: string;
  children: FolderDTO[];
};

export type LibraryItemDTO = {
  id: number;
  sourceId: number;
  source: 'folder' | 'document';
  name: string;
  uploadedBy: string;
  uploadedDate: string;
  projectId: number;
  isDeleted: boolean;
  inTrash: boolean;
};

export type LibraryItemDetailsDTO = {
  id: number;
  sourceId: number;
  source: 'folder' | 'document';
  name: string;
  uploadedBy: string;
  uploadedDate: Date;
  projectId: number;
  isDeleted: boolean;
  inTrash: boolean;
};

export type LibraryUserAccessDTO = {
  id: number | null;
  'first-name': string;
  'last-name': string;
  title: string;
  editable: boolean;
  avatar: string;
};

export type LibraryItemIdVersionedDTO = {
  id: number | null;
  version: number;
};

export type LibraryItemIdsVersionedDTO = LibraryItemIdVersionedDTO[];

export type TempBreadCrumbsDTO = { id: number; name: string }[];

export enum View {
  All = 'All',
  Files = 'Files',
  Trash = 'Trash',
}
